import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  ListItemIcon,
  Radio,
  Divider,
  RadioGroup,
  Slide,
  Slider,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import React, { useCallback, useContext, useState, useEffect } from "react";
import { Context } from "../../../../Context/context";
import { BrushItems } from "../../../../TypesAndConstants/Brushes";
import { ColorTheme } from "../../../../TypesAndConstants/const";
import {
  BrushItem,
  MenuActions,
  ShapeSetting,
} from "../../../../TypesAndConstants/types";
import getIconComponent from "../../../SketchUtilities/getBrushIcons";
import { THREE_INST } from "../../../SketchUtilities/Three/threeSingleton";
import ShapeContainer from "../../BottomMenu/Shapes/ShapeContainer";
import BrushSettingFactory from "../../BrushSideSettings/BrushSettingSideFactory";
import { navItems } from "../../Controls";
import { BrushSaveContainerMobile } from "../BrushSaveContainerMobile";
import { AnimationDropdown } from "./AnimationDropdown";
import { useAuth } from '../../../../../Splash/Context/AuthContext'
import { logBrush } from '../../../../../services/GAService'
const itemColor = {
  red: "red",
  blue: "blue",
  teal: "teal",
  green: "green",
  yellow: "yellow",
};

const Transition = React.forwardRef(function Transition(props: any, ref: any) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const menuActionToColor = (i: MenuActions) => {
  switch (i) {
    case "pen":
      return itemColor.teal;
    case "spring":
      return itemColor.yellow;
    case "wipe":
      return itemColor.blue;
    case "shape":
      return itemColor.red;
    default:
      return "black";
  }
};

export const BrushSettingsModal = () => {
  const {
    state: {
      activeBrush,
      brushbarIsCollapsed,
      brushType,
      brushSize,
      currentActiveMenu,
      shapeSettings,
      brushPlaybackRate
    },
    dispatch,
  } = useContext(Context);
  const auth = useAuth();

  let three = THREE_INST.getInst();
  const [isFullScreenModal, setIsFullScreenModal] = useState<boolean>(!isMobile)
  const [saveBrushOpen, setSaveBrushOpen] = useState<boolean>(false);
  const [loadBrushOpen, setLoadBrushOpen] = useState<boolean>(false);

  const closeMenus = useCallback(() => {
    setSaveBrushOpen(false);
    setLoadBrushOpen(false);
  }, []);

  const setCollapsed = (isCollapsed: boolean) => {
    three.obj.isMobileMenuOpen = false;
    dispatch({ type: "set_brushbar_collapsed", value: isCollapsed });
  };

  const setShapeRotationMode = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    const shape: ShapeSetting = {
      shape: shapeSettings.shape,
      shapeSize: shapeSettings.shapeSize,
      imageIndex: shapeSettings.imageIndex,
      shapeRotation: value as any,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const setShapeSize = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    const shape: ShapeSetting = {
      shape: shapeSettings.shape,
      imageIndex: shapeSettings.imageIndex,
      shapeSize: value as number,
      shapeRotation: shapeSettings.shapeRotation,
    };
    dispatch({ type: "set_shape", value: shape });
  };

  const setAnimationMode = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    three.obj.setAnimationMode(parseInt(event.target.value as string, 10));
    dispatch({
      type: "set_brush_animated",
      value: parseInt(event.target.value as string, 10),
    });
  };

  const setBrush = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    const brush = event.target.value as any;
    three.obj.setPreviewTexture(brush);
    three.obj.setTexture(brush, brushSize);
    logBrush( brush )
    dispatch({ type: "set_active_brush", value: brush });
  };

  const setActiveMenu = (value: MenuActions) => {
    dispatch({ type: "set_active_menu", value: value });
    dispatch({ type: "set_brush_type", value: value });
    if (
      value === "growshrink" 
    ) {
      setTimeout( ()=> dispatch({ type: "set_brush_speed", value: 34 }), 10 );
    }
    else if( 
      value === "wipe" ||
      value === "shape" ||
      value === "pen" ||
      value === "spring" 
    ) {
      dispatch({ type: "set_brush_count", value: 1 });
      setTimeout( ()=> dispatch({ type: "set_brush_speed", value: 0.1 }), 10 );
    }
  };

  const sessionButtonGroup = () => {
    return (
      <ButtonGroup>
        <Button
          variant="contained"
          onClick={() => {
            setSaveBrushOpen(true);
            setLoadBrushOpen(false);
          }}
          color="primary"
        >
          Save Brush
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setLoadBrushOpen(true);
            setSaveBrushOpen(false);
          }}
          color="primary"
        >
          Load Brush
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setCollapsed(true);
          }}
          color="primary"
        >
          Close
        </Button>
      </ButtonGroup>
    );
  };

  const noSessionButton = () => {
    return (
      <Button
        autoFocus
        variant="contained"
        onClick={() => {
          setCollapsed(true);
        }}
        color="primary"
      >
        Close
      </Button>
    );
  };

  const brushList = () => {
    return (
      <div
        style={{
          margin: "10px 0",
          background: "white",
          padding: "10px",
          border: `2px solid ${ColorTheme.primaryText}`,
          borderRadius: "5px",
          boxShadow: "4px 4px 8px",
        }}
      >
        {navItems.map((i: MenuActions) => (
          <div
            onClick={() => {
              setActiveMenu(i);
            }}
            className={"brushNavItem"}
            key={i}
            style={{
              borderBottom:
                i === currentActiveMenu
                  ? `8px solid ${menuActionToColor(i)}`
                  : "",
            }}
          >
            <ListItemIcon style={{ width: "100%" }}>
              {getIconComponent(i)}
            </ListItemIcon>
            <div style={{ textAlign: "center" }}>
              {i === "growshrink" ? "G/S" : i}
            </div>
          </div>
        ))}
      </div>
    );
  };
  /* eslint react-hooks/exhaustive-deps: off */
  useEffect(()=>
  {
    if( isMobile !== isFullScreenModal ) {
      setIsFullScreenModal(isMobile)
    }
  },[isMobile])
  
  return (
    <>
      {BrushSaveContainerMobile({
        openSave: saveBrushOpen,
        openLoad: loadBrushOpen,
        closeMenus: closeMenus,
      })}
      <Dialog
        scroll={"paper"}
        open={!brushbarIsCollapsed}
        aria-labelledby="form-dialog-title"
        fullScreen={ isFullScreenModal } 
        style={{
          zIndex: 1000000000,
          fontFamily: "amatic",
          fontSize: "1.8rem",
        }}
        TransitionComponent={Transition as any}
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ fontFamily: "carter, cursive" }}
        >
          Brush Settings
        </DialogTitle>
        <DialogContent
          dividers
          className={"mobileDialogRoot"}
          id={"placeholder"}
        >
          <div>
            <div
              id={"previewCanvasMobile"}
              style={{
                display: brushType === "shape" ? "none" : "flex",
                justifyContent: "center",
                margin: "0 auto",
                height: "100px",
                width: "100px",
                background: "white",
                borderRadius: "10px",
                border: `2px solid ${ColorTheme.primaryText}`,
              }}
            />
            {brushList()}
            <div
              style={{
                margin: "10px 0",
                background: "white",
                padding: "10px",
                border: `2px solid ${ColorTheme.primaryText}`,
                borderRadius: "5px",
                boxShadow: "4px 4px 8px",
              }}
            >
              <div
                style={{
                  verticalAlign: "top",
                  display: brushType === "shape" ? "none" : "grid",
                }}
              >
                <FormControl
                  variant="outlined"
                  style={{
                    minWidth: "120px",
                    margin: "4px",
                    width: "100%",
                  }}
                >
                  <label style={{ padding: "2px" }}>
                    <h4 style={{ display: "inline", marginRight: "4px" }}>
                      Brush:
                    </h4>
                    <select
                      value={activeBrush}
                      onChange={setBrush}
                      style={{ float: "right", marginRight: "15px", fontSize: "1.5rem"}}
                    >
                      {BrushItems.map((brush: BrushItem) => {
                        return (
                          <option key={brush.name} value={brush.brushType}>
                            {brush.name}
                          </option>
                        );
                      })}
                    </select>
                  </label>
                </FormControl>
                {AnimationDropdown(setAnimationMode)}
                <FormControl
                  variant="outlined"
                  style={{ minWidth: "120px", margin: "4px" }}
                >
                  <label style={{ padding: "2px" }}>
                    <h4 style={{ display: "inline", marginRight: "4px" }}>
                      Size:
                    </h4>
                    <span
                      style={{
                        marginLeft: "4px",
                      }}
                    >
                      {brushSize + "px"}
                    </span>
                    <Slider
                      onChange={(e, v) => {
                        dispatch({
                          type: "set_brush_size",
                          value: v as any,
                        });
                      }}
                      min={1}
                      max={400}
                      step={0.1}
                      value={brushSize || 25}
                    />
                  </label>
                </FormControl>
                <FormControl
                  variant="outlined"
                  style={{ minWidth: "120px", margin: "4px" }}
                >
                  <label style={{ padding: "2px" }}>
                    <h4
                      style={{
                        display: "inline",
                        marginRight: "4px",
                      }}
                    >
                      Speed:
                    </h4>
                    <span
                      style={{
                        marginLeft: "4px",
                      }}
                    >
                      {three.obj.vidPlaybackRate + "px"}
                    </span>
                  </label>
                  <Slider
                    onChange={(e, v) => {
                      dispatch({
                          type: "set_brush_playback_speed",
                          value: v as number,
                        })
                      three.obj.setPlaybackRate(v as number);
                    }}
                    min={0.1}
                    max={4}
                    step={0.1}
                    value={brushPlaybackRate}
                  />
                </FormControl>
              </div>

              {brushType === "shape" && (
                <>
                  <div>
                    {" "}
                    <label>Size</label>
                    <Slider
                      defaultValue={3}
                      aria-labelledby="discrete-slider-small-steps"
                      onChange={setShapeSize}
                      step={1}
                      min={1}
                      max={2000}
                      valueLabelDisplay="auto"
                      value={shapeSettings.shapeSize}
                    />
                  </div>
                  <div>
                    <RadioGroup
                      value={shapeSettings.shapeRotation}
                      onChange={setShapeRotationMode}
                      id={"shapeRadioButton"}
                      row
                    >
                      <FormControlLabel
                        value="sliding"
                        control={<Radio />}
                        labelPlacement="start"
                        label="Allow Sliding"
                        style={{
                          fontFamily: "'amatic', cursive",
                          fontSize: "20px",
                        }}
                      />
                      <Divider />
                      <FormControlLabel
                        value="rotation"
                        control={<Radio />}
                        labelPlacement="start"
                        label="Allow Rotation"
                        style={{ fontFamily: "'amatic', cursive" }}
                      />
                      <Divider />
                      <FormControlLabel
                        value="drag"
                        control={<Radio />}
                        labelPlacement="start"
                        label="Free Drag"
                        style={{ fontFamily: "'amatic', cursive" }}
                      />
                    </RadioGroup>
                  </div>
                  <ShapeContainer isMobile />
                </>
              )}
              {brushType !== "shape" && (
                <BrushSettingFactory
                  activeBrush={brushType}
                  useMobileFontSize={true}
                />
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          { auth.state.isLoggedIn
            ? sessionButtonGroup()
            : noSessionButton()}
        </DialogActions>
      </Dialog>
    </>
  );
  
};
